let pos_comp_Payment = require("../../templates/pos/comp/Payment.handlebars");
let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
import i18n from "../../utils/i18n";
import ValidationView from "../comp/ValidationView.js";
import POS from "../../POS.js";

let main = function () {
    return Backbone.View.extend({
        pageView: null,

        events: {
            'click .create': 'showModal',
            'click .modal .ok': 'createPayment',
            'click .modal .delete': 'deletePayment',
            'click .customer-pay': 'showEditModal',
            'click .save': 'saveSetting',
            'click .paymentList .payment': "selectPayment",
            'click .paymentList .payment .glyphicon': "editPayment"
        },
        deletePayment: function () {
            var id = this.$('.modal .modal-content').data('data-id'),
                url = '/paymentNote/removeCustomPayment/' + id,
                result, self = this;
            POS.showLoading(true);
            result = $.get(url);
            result.done(function (res) {
                if (res.success) {
                    self.$('.payment[data-id="' + id + '"]').remove();
                    self.closeModal();
                    self.trigger('needRefresh');
                } else {
                    self.$('.modal .form-group.paymentNameInput').addClass('has-error').find('.help-block').text(res.error);
                }

            });

            result.error(function (res) {
                self.$('.modal .form-group.paymentNameInput').addClass('.has-error').find('.help-block').text("!!!!");
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
        },
        createPayment: function () {
            var validation = new ValidationView({el: this.$('#paymentNameInput')}),
                id = this.$('.modal .modal-content').data('data-id'),
                url = id ? '/paymentNote/editCustomPayment' : '/paymentNote/createCustomPayment',
                result, self = this;

            if (this.$('#paymentNameInput').val().length > 20) {
                alert(i18n.msg("pos.setting.payment.name.error"));
                this.$('#paymentNameInput').focus();
                return;
            }

            if (!validation.notEmpty().isValid()) {
                validation.render();
                return;
            }
            POS.showLoading(true);
            result = $.post(url, {
                paymentName: this.$('#paymentNameInput').val(),
                paymentMode: this.$('#paymentMode').val(),
                restaurantId: POS.getRestaurant().id,
                customerId: id,
            });
            result.done(function (res) {
                if (res.success) {
                    self.$('.payment[data-id="' + id + '"]').remove();
                    var customerPayView = $(pos_comp_Payment(res));
                    self.$(".paymentList").prepend(customerPayView);
                    self.closeModal();
                    self.trigger('needRefresh');
                } else {
                    self.$('.modal .form-group.paymentNameInput').addClass('has-error').find('.help-block').text(res.error);
                }

            });

            result.error(function (res) {
                self.$('.modal .form-group.paymentNameInput').addClass('.has-error').find('.help-block').text("!!!!");
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
        },
        editPayment: function (evt) {
            var modal = this.$('.modal');
            modal.find('.modal-content').addClass("settingsModal");
            modal.find('.form-group').removeClass('has-error');
            modal.find('.help-block').text("");
            modal.find('.delete').removeClass('hidden');
            modal.find('.ok').addClass("saveCreate-btn");
            modal.find('.modal-content').data('data-id', $(evt.currentTarget).closest(".payment").data("id"));
            modal.find('#paymentNameInput').val($(evt.currentTarget).closest(".payment").data("name"));
            modal.find('#paymentMode').val($(evt.currentTarget).closest(".payment").data("mode"));
            modal.find('.modal-title').text('编辑支付方式');
            modal.modal('show');
            return false;
        },
        showModal: function () {
            var modal = this.$('.modal');
            modal.find('.modal-content').addClass("settingsModal");
            modal.find('.form-group').removeClass('has-error');
            modal.find('.help-block').text("");
            modal.find('.delete').addClass('hidden');
            if (modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').removeClass("saveEdit-btn");
            }
            if (!modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').addClass("saveCreate-btn");
            }
            modal.data('data-id', null).modal('show');
            modal.find('.modal-title').text('新加支付方式');
        },

        showEditModal: function (evt) {
            var modal = this.$('.modal');
            modal.find('.modal-content').addClass('settingsModal');
            modal.find(".form-group").removeClass("has-error");
            modal.find('.help-block').text("");
            modal.find('.delete').removeClass('hidden');
            if (modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').removeClass("saveCreate-btn");
            }
            if (!modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').addClass("saveEdit-btn");
            }
            modal.find('.modal-title').text('编辑支付方式');
            modal.data('data-id', $(evt.currentTarget).data("id")).modal('show');
        },
        saveSetting: function () {
            var self = this, jxhr, paymentSelect = $(".paymentList .payment.selected"), payments = [];
            if (paymentSelect.length != 3) {
                alert("请选择三种常用支付方式");
                return false;
            }
            _.each(paymentSelect, function (payment) {
                var params = {mode: $(payment).data("mode")};
                if ($(payment).data("id")) {
                    params.id = $(payment).data("id");
                }
                payments.push(params);
            });
            jxhr = $.post("/restaurant/updateDefaultPaymentMethods", {payments: JSON.stringify(payments)});
            jxhr.done(function (response) {
                if (response.success) {
                    $('.saveSuccessDiv').removeClass('hidden');
                    setTimeout(function () {
                        $('.saveSuccessDiv').addClass('hidden')
                    }, 1000);
                    self.trigger('needRefresh');
                } else {
                    alert(i18n.msg('pos.serverError'));
                }
            });
            jxhr.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });
        },

        selectPayment: function (evt) {
            var choose = $(evt.currentTarget);
            if (choose.hasClass("selected")) {
                choose.removeClass("selected");
                return;
            }
            if ($(".paymentList .payment.selected").length >= 3) {
                alert("选择达到上限");
                return false;
            }
            choose.addClass("selected");
        },

        closeModal: function () {
            this.$('.modal').modal('hide');
        }

    });
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/settings/PaymentSettingView.js